/**
 * Created by Florin David on 25/09/2019.
 */
export const SERVICE_WORKER_ERROR = 'Failed to update a ServiceWorker:'
export const DB_ERROR =
  'IDBFactory.open() called in an invalid security context'
export const SCRIPT_ERROR = 'Script error.'
export const OFFLINE_ERROR =
  'Request has been terminated\n' +
  'Possible causes: the network is offline, Origin is not allowed by ' +
  'Access-Control-Allow-Origin, the page is being unloaded, etc.'
